import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';
import { useLocation, useNavigate, useParams } from "react-router-dom";

export function CancelBookingModal({ apartmentReview, setApartmentReview, setShowReviewModal, getData }) {
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const navigate = useNavigate();

async function cancelReservation() {
    if (comment == "") {
      setTostMessage({
        messageType: 'error',
        message: 'Please enter a comment'
      })
      return;
    }
    if (window.confirm("Are you sure you want to cancel this reservation?")) {
        const formData = new FormData();
        formData.append('rrr', apartmentReview?.rrr);
        formData.append('comment', comment);
        
        setLoading(true)
        try {
            const response = await axios.post(base_url + '/cancel-booking.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setLoading(false)
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                setShowReviewModal(false);
                setApartmentReview({});
                navigate(-1);
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
        } catch (error) {
            setLoading(false)
            setTostMessage({
                messageType: 'error',
                message: "Network Error"
            })
        }
    }
}

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div onClick={() => setShowReviewModal(false)} className='w-[80%] flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                    <a className='text-dark text-[20px] font-bold'>Cancel Booking</a>
                    
                    {/* Comment Box */}
                    <textarea
                    className="w-[80%] mt-3 mx-auto border border-gray-300 rounded-lg p-3 h-28 outline-none focus:border-blue-500"
                    placeholder={`Why are you cancelling?`}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    />

                    {/* Buttons */}
                    <div className="flex justify-between mt-5">
                        <button
                            onClick={() => cancelReservation()}
                            className="
                            bg-[#ff0000] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Cancel Booking
                        </button>
                    </div>
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

